import { useLazyFetch, useLazyPost } from "../utils/apiclient";
import { devopsUrl, backendUrl, rmsUrl } from "../utils/urls";
import { getHeaders } from "../utils/apiclient";

export const getReleasesUrl = (appGroup) =>
  `${devopsUrl}/applications/app-groups/${appGroup}/release-labels`;

export const getReleasesUrl2 = (app) => `${backendUrl}/apps/${app}/releases`;

export const useGetAppGroups = () => {
  return useLazyFetch(`${devopsUrl}/applications/app-groups`, {
    headers: getHeaders(),
  });
};

export const useGetReleases = (appGroup) => {
  return useLazyFetch(getReleasesUrl(appGroup), {
    headers: getHeaders(),
  });
};

export const usePatchReleaseStatus = (app) => {
  return useLazyPost(getReleasesUrl2(app), {
    headers: { ...getHeaders(), Action: "UPDATE_PARENT_STATUS" },
    method: "PATCH",
  });
};

export const useGetPatch = (appGroup) => {
  return useLazyFetch(getReleasesUrl(appGroup), {
    headers: getHeaders(),
  });
};

export const useCreateLabel = (app) => {
  return useLazyPost(getReleasesUrl2(app), {
    headers: { ...getHeaders(), Action: "CREATE" },
    method: "POST",
  });
};

export const usePatchLabel = (app) => {
  return useLazyPost(getReleasesUrl2(app), {
    headers: { ...getHeaders(), Action: "CREATE" },
    method: "POST",
  });
};

export const useListAllReleasesWithDetails = (app) => {
  return useLazyFetch(`${rmsUrl}/apps/${app}/releases`, {
    headers: { ...getHeaders(), Action: "LIST_WITH_DETAILS" },
  });
};

export const useUpdateReleaseStatus = (app) => {
  return useLazyFetch(`${rmsUrl}/apps/${app}/releases`, {
    method: "PATCH",
  });
};

export const useCreateReleaseLabel = (app) => {
  return useLazyPost(`${rmsUrl}/apps/${app}/releases`, {
    headers: { ...getHeaders(), Action: "CREATE" },
    method: "POST",
  });
};
